import React from 'react';
import { X } from 'lucide-react';

export function UnsavedChangesDialog({ onSave, onDiscard, onCancel }) {
  return (
    <div style={{position:'fixed',inset:0,zIndex:1100,background:'rgba(0,0,0,.55)',display:'flex',alignItems:'center',justifyContent:'center'}}>
      <div style={{background:'var(--bg)',borderRadius:'var(--radius)',padding:'24px',maxWidth:420,width:'90%',boxShadow:'0 8px 40px rgba(0,0,0,.3)'}}>
        <h4 style={{margin:'0 0 10px',fontSize:15}}>Ungespeicherte Änderungen</h4>
        <p style={{margin:'0 0 20px',fontSize:13,color:'var(--muted)',lineHeight:1.5}}>
          Es gibt ungespeicherte Änderungen. Möchten Sie speichern oder ohne Speichern schließen?
        </p>
        <div style={{display:'flex',gap:8,justifyContent:'flex-end',flexWrap:'wrap'}}>
          <button className="btn btn-ghost btn-sm" onClick={onCancel}>Abbrechen</button>
          <button className="btn btn-danger btn-sm" onClick={onDiscard}>Ohne Speichern schließen</button>
          {onSave && <button className="btn btn-primary btn-sm" onClick={onSave}>Speichern &amp; Schließen</button>}
        </div>
      </div>
    </div>
  );
}

export default function Modal({ title, children, onClose, size = '' }) {
  return (
    <div className="modal-overlay">
      <div className={`modal ${size==='lg'?'modal-lg':size==='xl'?'modal-xl':''}`}>
        <div className="modal-header">
          <h3 className="modal-title">{title}</h3>
          <button className="modal-close" onClick={onClose}><X size={16}/></button>
        </div>
        <div className="modal-body">{children}</div>
      </div>
    </div>
  );
}
